import { encryptAesGcm } from "./crypto_aes";
import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN, SECRET_KEY, STORAGE_KEYS } from "../config/vars";

function storeAccessToken(data) {
    const token = (data?.access_token || "").trim();
    if (!token) return;
    try {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
    } catch (_) {
        // ignore
    }
}

export const loginUser = async (email, password) => {
    if (!SECRET_KEY) {
        throw new Error("Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)");
    }

    // Encrypt password before sending
    const encryptedPassword = await encryptAesGcm(SECRET_KEY, password);
    const headers = {
        "Content-Type": "application/json",
        "X-Return-Token": "1",
    };

    const response = await apiFetch(`${API_BASE_ADMIN}/login/admin`, {
        method: "POST",
        headers,
        body: JSON.stringify({ email, password: encryptedPassword }),
    });

    if (!response.ok) {
        throw new Error("Невірний email або пароль");
    }

    const data = await response.json();
    storeAccessToken(data);
    return data;
};

export const verifyCode = async (email, code) => {
    const headers = {
        "Content-Type": "application/json",
        "X-Return-Token": "1",
    };

    const response = await apiFetch(`${API_BASE_ADMIN}/login/admin/verify-code`, {
        method: "POST",
        headers,
        body: JSON.stringify({ email, code }),
    });

    if (!response.ok) {
        throw new Error("Невірний код");
    }

    const data = await response.json();
    storeAccessToken(data);
    return data;
};

export const forgotPassword = async (email) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/login/admin/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
    });

    if (!response.ok) {
        throw new Error("Помилка при відновленні пароля");
    }
    return await response.json();
};

export const resetPassword = async (token, newPassword) => {
    if (!SECRET_KEY) {
        throw new Error("Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)");
    }

    const encryptedNewPassword = await encryptAesGcm(SECRET_KEY, newPassword);
    const response = await apiFetch(`${API_BASE_ADMIN}/login/admin/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: encryptedNewPassword }),
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || "Помилка при зміні пароля");
    }
    return await response.json();
};
